module.exports = __webpack_public_path__ + "static/media/5.f25f70ae.png";